import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { useGetList, useRecordContext } from 'react-admin';

import OperationalInfoCard from './OperationalInfoCard';
import TenureHistoryCard from './TenureHistoryCard';

const PAGINATION = { page: 1, perPage: 1 };
const SORT = { field: 'created_at', order: 'DESC' };

const TabOperational = (props) => {
  const account = useRecordContext(props);
  const accountId = account ? account.id : null;

  const { data, ids, loading, error } = useGetList(
    'account_operational_info',
    PAGINATION,
    SORT,
    { account_id: accountId },
    { enabled: Boolean(accountId) },
  );

  const record = ids && ids.length > 0 ? data[ids[0]] : null;

  return (
    <Grid container spacing={2}>
      <OperationalInfoCard record={record} isLoading={loading} error={error} />
      <TenureHistoryCard
        {...props}
        record={record}
        isLoading={loading}
        error={error}
      />
    </Grid>
  );
};

TabOperational.propTypes = {
  record: PropTypes.object,
};

TabOperational.defaultProps = {
  record: undefined,
};

export default TabOperational;
